var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

function resizeElements() {
    var navWidth = $('#mega-menu-main-nav').outerWidth();
    var programsWidth = $('.mega-programs-services a').outerWidth();
    var involvedWidth = $('.mega-get-involved a').outerWidth();
    // var calcWidth = navWidth - programsWidth;
    var width = navWidth - programsWidth - involvedWidth - 150;


    if ($(window).width() > 1280) {
        $('.mega-about').css('width', (width / 2));
        $('.mega-resources').css('width', (width / 2));
    } else {
        $('.mega-about, .mega-resources').removeAttr('style');
    }
}
// $(document).on('keypress', function (e) {
//     if ($('#input_18_1').is(':focus') && e.which == 13) {
//         $('#gform_submit_button_18').trigger('click');
//     }
    
// });

$(document).ready(function () {
    setTimeout(function(){
        resizeElements();
        var count_elements = $('.page-template-secondary-page-template .masonry .text-center').length;
        var half_count_elements = Math.round(count_elements / 2);

        if ($(window).width() > 1365) {
            $('.page-template-secondary-page-template .masonry .text-center').css('height', (mainContentHeight / half_count_elements));
        } else if ($(window).width() < 1365) {
            $('.page-template-secondary-page-template .masonry .text-center').css('height', (mainColumnHeight / count_elements));
        }
    }, 200);

    $('.open-search').click(function () {
        $('.search-container').addClass('active');
    });
    $('.search-container .close-search').click(function () {
        $(this).parent().removeClass('active');
    });

    $('#nameSearch').attr('placeholder', 'agency name');

    var controller = new ScrollMagic.Controller();
    // custom accordion colors
    var headCount = 0;
    var contentCount = 0;
    
    var mainContentHeight = $('.main-content').outerHeight();
    var mainColumnHeight = $('.page-template-secondary-page-template .masonry .main-column.right .container').outerHeight();

    $(window).bind('resize', function (e) {
        window.resizeEvt;
        $(window).resize(function () {
            clearTimeout(window.resizeEvt);
            window.resizeEvt = setTimeout(function () {
                $('.mega-about').removeAttr('style');
                $('.mega-resources').removeAttr('style');
                var mainContentHeight = $('.main-content').outerHeight();
                var mainColumnHeight = $('.page-template-secondary-page-template .masonry .main-column.right .container').outerHeight();
                var count_elements = $('.page-template-secondary-page-template .masonry .text-center').length;
                var half_count_elements = Math.round(count_elements / 2);

                if ($(window).width() > 1365) {
                    $('.page-template-secondary-page-template .masonry .text-center').css('height', (mainContentHeight / half_count_elements));
                } else if ($(window).width() < 1365) {
                    $('.page-template-secondary-page-template .masonry .text-center').css('height', (mainColumnHeight / count_elements));
                }
                resizeElements();
            }, 200);
        });
    });

    $('.accordions-head').each(function () {
        if (headCount > 3) {
            headCount = 0;
        }
        headCount++;
        if (headCount == 2) {
            $(this).addClass('bg-dark-green');
        } else if (headCount == 3) {
            $(this).addClass('bg-light-pink');
        } else if (headCount == 4) {
            $(this).addClass('bg-purple');
        }
    });
    $('.accordion-content').each(function () {
        if (contentCount > 3) {
            contentCount = 0;
        }
        contentCount++;
        if (contentCount == 2) {
            $(this).addClass('bg-dark-green');
        } else if (contentCount == 3) {
            $(this).addClass('bg-light-pink');
        } else if (contentCount == 4) {
            $(this).addClass('bg-purple');
        }
    });
});